import { MarkdownComponent } from '@/models/markdown';
import { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownProps {
  content: string;
  components?: Record<string, FC<MarkdownComponent>>;
}

const Markdown: FC<MarkdownProps> = ({ content, components = null }) => {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
      {content}
    </ReactMarkdown>
  );
};

export default Markdown;
